import { Route } from 'react-router-dom';

import Layout from '../components/layout';
import ProtectedRoute from '../components/ProtectedRoute';

import AllPosts from '../Pages/Blog/AllPosts';
import NewPost from '../Pages/Blog/NewPost';
import AllCategories from '../Pages/Blog/Category/AllCategories';

import { hasPermission } from '../utils/functions';

export const BlogRoutes = ({ menuActive, setMenuActive }) => (
  <>
    { hasPermission('blog') && (
      <Route path="/blog" element={
        <ProtectedRoute>
          <Layout activePage='blog' menuActive={menuActive} setMenuActive={setMenuActive}>
            <AllPosts />
          </Layout>
        </ProtectedRoute>
      } />
    )}

    { hasPermission('blogCategory') && (
      <Route path="/blog/category" element={
        <ProtectedRoute>
          <Layout activePage='blog/category' menuActive={menuActive} setMenuActive={setMenuActive}>
            <AllCategories />
          </Layout>
        </ProtectedRoute>
      } />
    )}

    { hasPermission('blog') && (
      <Route path="/new-blog" element={
        <ProtectedRoute>
          <Layout activePage='new-blog' menuActive={menuActive} setMenuActive={setMenuActive}>
            <NewPost />
          </Layout>
        </ProtectedRoute>
      } />
    )}

    { hasPermission('blog') && (
      <Route path="/blog/:blogId" element={
        <ProtectedRoute>
          <Layout activePage='edit-blog' menuActive={menuActive} setMenuActive={setMenuActive}>
            <NewPost />
          </Layout>
        </ProtectedRoute>
      } />
    ) }
  </>
);
